import { useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import images from '../../../images';
import CongratulationsModal from './CongratulationsModal';
import Answers from './Answers';
import Levels from './Levels';
import { __ } from '../../../locales';
import { trackEvent } from '../../../helpers/common';
import events from '../../../app/events';

const LevelResultContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 15px 0px;
  top: 0;
  bottom: 0;
  position:fixed;
  overflow-y: scroll;
  overflow-x: hidden;
`;

const LevelText = styled.h2`
  margin-top: 3%;
  font-size: 30px;
`;

const ScoreText = styled.p`
  margin-top: 3%;
  font-size: 20px;
  color: #000;
  font-weight: 700;
`;

const CheckOutText = styled.p`
  margin-top: 3%;
  font-size: 15px;
  color: #808080;
  text-align: center;
`;

const FeedbackContainer = styled.div`
  margin-top: 3%;
  display: flex;
  margin: auto;
  flex-direction: column;
`;

const FeedbackImage = styled.div`
  margin-top: 3%;
  background-size: contain;
  background-position: center;
  width: 80px;
  height: 80px;

  &.good{
    background-image: url(${images.happy_emoji});
  }
  
  &.oops{
    background-image: url(${images.sad_emoji});
  }
`;

const FeedbackText = styled.div`
  text-align: center;
  margin-top: 3%;
  h3 { margin-top: 15px; font-size: 23px; font-weight: normal; }
  p { margin-top: 8px; }
`;

const Button = styled.button`
  height: 50px;
  width: 90vw;
  position: fixed;
  bottom: 1%;
  left: 5%;
  background-color: ${process.env.REACT_APP_COLOR_RC_ROYAL};
  color: white;
  box-shadow:
  20px 20px 50px 50px rgba(0, 0, 0, 0.5);
`;

const AnswersContainer = styled.div`
  margin-left: 5%;
  margin-top: 3%;
  margin-bottom: 25%;
  flex-direction: column;
`;

const CloseImage = styled.img`
  height: ${window.innerWidth / 20}px;
  width: ${window.innerWidth / 20}px;
  border-radius: 50%;
  margin-top: 2%;
  margin-left: 8%;
  margin-right: 92%;
`;

const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
  align-self: flex-start;
  padding: 30px;
`;

const levelState = {
  oops: (
    <>
      <FeedbackContainer>
        <FeedbackImage role="img" alt="Oops feedback" className="oops animate__animated animate__wobble" />
        <FeedbackText>
          <h3>{__('app.oops')}</h3>
        </FeedbackText>
      </FeedbackContainer>
      <CheckOutText>
        {__('app.check_out_local_program')}
      </CheckOutText>
    </>
  ),
  goodJob: (
    <FeedbackContainer>
      <FeedbackImage role="img" alt="Good job feedback" className="good animate__animated animate__rubberBand" />
      <FeedbackText>
        <h3>{__('app.good_job')}</h3>
      </FeedbackText>
    </FeedbackContainer>
  )
};

/**
 * After user answer all the questions of a level, this component shows
 * the correct and wrongs answers with their corresponding details and images
 *
 */

const RoundResult = ({
  clearedLevel,
  onContinue,
  onPlayAgain,
  doneMaterials,
  currentLevelKey,
  recycleRightData,
  playAgain,
  onCloseModal,
  iamDone,
  numOfTimeOuts
}) => {
  const roundMaterials = recycleRightData[currentLevelKey];
  const numOfRounds = roundMaterials.length;
  const currentDnMt = doneMaterials.slice(doneMaterials.length - numOfRounds, doneMaterials.length);

  const correctAnswers = currentDnMt.filter((mat) => mat.split('-')[0] === 'correct');
  const numOfCorrectAnswers = correctAnswers.length;
  const currentCorrctAnswersId = correctAnswers.map((mat) => mat.split('-')[1]);
  const correctAnswersMaterials = {
    roundMaterials: roundMaterials.filter((mat) => currentCorrctAnswersId.indexOf(
      mat.mat_id.toString()
    ) > -1)
  };

  const wrongAnswers = currentDnMt.filter((mat) => mat.split('-')[0] === 'wrong');
  const numOfWrongAnswers = wrongAnswers.length;
  const currentWrongAnswersId = wrongAnswers.map((mat) => mat.split('-')[1]);
  const wrongAnswersMaterials = {
    roundMaterials: roundMaterials.filter((mat) => currentWrongAnswersId.indexOf(
      mat.mat_id.toString()
    ) > -1)
  };

  const levelStatus = (numOfCorrectAnswers / (numOfCorrectAnswers + numOfWrongAnswers) >= 0.8) ? 'goodJob' : 'oops';

  const congratsModalVisible = (Number(currentLevelKey.split('_')[1].split('_')[0]) === (Object.keys(recycleRightData).length)) && levelStatus === 'goodJob';

  useEffect(() => {
    if (levelStatus === 'oops') {
      // track event
      trackEvent(events.DZ_RR_LEVEL_FAIL, {
        level: Number(currentLevelKey.split('_')[1].split('_')[0]),
        correct: numOfCorrectAnswers,
        total: numOfCorrectAnswers + numOfWrongAnswers,
        timeouts: numOfTimeOuts
      });
    }
    if (levelStatus === 'goodJob') {
      // track event
      trackEvent(events.DZ_RR_LEVEL_SUCCESS, {
        level: Number(currentLevelKey.split('_')[1].split('_')[0]),
        correct: numOfCorrectAnswers,
        total: numOfCorrectAnswers + numOfWrongAnswers,
        timeouts: numOfTimeOuts
      });
    }
  }, [levelStatus]);

  return (
    <>
      {congratsModalVisible
        && (
          <CongratulationsModal
            isVisible={congratsModalVisible}
            onContinue={onContinue}
            clearedLevel={clearedLevel}
            playAgain={playAgain}
            onClose={onCloseModal}
            iamDone={iamDone}
          />
        )}
      <LevelResultContainer>
        <CloseButton accessibilityLabel="Close" onClick={iamDone}>
          <CloseImage src={images.close} alt="Close" />
        </CloseButton>

        <div style={{ width: '100%' }}>
          <Levels
            levels={recycleRightData}
            currentLevelKey={currentLevelKey}
            modalVisible="true"
          />
        </div>
        <LevelText>
          {__('app.level_lower_case')}
          {' '}
          {clearedLevel}
        </LevelText>
        <ScoreText className={(levelStatus === 'goodJob' && 'goodJob') || (levelStatus === 'oops' && 'oops')}>
          {__('app.score')}
          {' '}
          {numOfCorrectAnswers}
          {'/'}
          {numOfCorrectAnswers + numOfWrongAnswers}
        </ScoreText>
        {levelState[levelStatus]}
        <AnswersContainer>
          <Answers
            answerTitle="WRONG ANSWERS"
            answersMaterials={wrongAnswersMaterials}
          />
          <Answers
            answerTitle="CORRECT ANSWERS"
            answersMaterials={correctAnswersMaterials}
          />
        </AnswersContainer>
        {
          levelStatus === 'goodJob' && !congratsModalVisible && (
            <Button onClick={onContinue}>
              {__('app.next_level_button')}
            </Button>
          )
        }
        {
          levelStatus === 'oops' && (
            <Button onClick={onPlayAgain}>
              {__('app.play_again_button')}
            </Button>
          )
        }
        {
          levelStatus === 'goodJob' && congratsModalVisible && (
            <Button onClick={iamDone}>
              {__('app.done')}
            </Button>
          )
        }
      </LevelResultContainer>
    </>
  );
};

export default connect(
  (store) => ({
    recycleRightData: store.recycleRight.allRrData,
  })
)(RoundResult);
